import { Box, Typography, Chip } from "@mui/material";
import { StickyNote2, VideoLibrary, Description } from "@mui/icons-material";
import { truncateString } from "../../../../utils/truncate-string";
import { useNavigate } from "react-router-dom";
import { Collection } from "../../../../models/collection";

interface CollectionPreviewCardProps {
  collection: Collection;
}

export function CollectionPreviewCard({ collection }: CollectionPreviewCardProps) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: 80,
        backgroundColor: "white",
        border: 1,
        borderColor: 'grey.300',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: 2,
          borderColor: 'grey.400',
        },
      }}
      onClick={() =>
        navigate(
          `/classrooms/${collection.classroom_id}/library/collections/${collection.id}`
        )
      }
    >
      {/* Header Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box sx={{ flex: 1 }}>
          <Typography 
            variant="subtitle2"
            sx={{
              fontWeight: 'bold',
              marginBottom: '4px',
              lineHeight: 1.2
            }}
          >
            {truncateString(collection.title, 25)}
          </Typography>
        </Box>
      </Box>

      {/* Icons and counts */}
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'flex-end', 
        alignItems: 'center',
        mt: 'auto'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {collection.notes > 0 && (
            <Chip
              icon={<StickyNote2/>}
              label={collection.notes}
              size="small"
              sx={{
                backgroundColor: '#eef2ff',
                color: '#4f46e5',
                fontWeight: 600,
                fontSize: '0.7rem',
                height: 24,
                '& .MuiChip-label': {
                  px: 1,
                },
                '& .MuiChip-icon': {
                  marginLeft: 1,
                  marginRight: -0.5,
                  fontSize: 16,
                  color:"#4f46e5"
                }
              }}
            />
          )}
          {collection.medias > 0 && (
            <Chip
              icon={<VideoLibrary />}
              label={collection.medias}
              size="small"
              sx={{
                backgroundColor: '#fef2f2',
                color: '#e11d48',
                fontWeight: 600,
                fontSize: '0.7rem',
                height: 24,
                '& .MuiChip-label': {
                  px: 1,
                },
                '& .MuiChip-icon': {
                  marginLeft: 1,
                  marginRight: -0.5,
                  fontSize: 16,
                  color:"#e11d48"
                }
              }}
            />
          )}
          {collection.documents > 0 && (
            <Chip
              icon={<Description/>}
              label={collection.documents}
              size="small"
              sx={{
                backgroundColor: '#ecfeff',
                color: '#0891b2',
                fontWeight: 600,
                fontSize: '0.7rem',
                height: 24,
                '& .MuiChip-label': {
                  px: 1,
                },
                '& .MuiChip-icon': {
                  marginLeft: 1,
                  marginRight: -0.5,
                  fontSize: 16,
                  color:"#0891b2"
                }
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}
